// IE 2026 10 18 / ODOO-5800 (Igor, п. 5 плана: отчёты планов по уровням — DL2 WIDGET-REPORT2 над документами SALES-CALC-<уровень>): чистая логика без Vue и wijmo
// (юнит — tests/unit/planLevels.test.mjs) для четырёх вещей, которые рисует фронт по мете строки / ячейки отчёта планов:
//   1. класс ячейки по происхождению значения — `plan-manual` (ручная корректировка: синий треугольник в углу ячейки, CSS в AttrGrid.vue);
//   2. класс ячейки по статусу единицы — `plan-approved` (утверждено, светло-зелёный) / `plan-draft` (к утверждению, светло-янтарный) / `plan-returned`
//      (возвращено / аннулировано, янтарный с оранжевой рамкой) / `plan-locked` (заморожено, серый); «вне окна» и неизвестный статус — без класса;
//   3. класс заголовка колонки по горизонту — `plan-horizon-tactical` / `plan-horizon-strategic` (полоса вверху заголовка: синяя / сиреневая);
//   4. чипы статуса по горизонтам в заголовке строки — `_DLRow.status_chips: [{horizon, status, title, due}]` → «T · <title>», «S · <title>».
// Контракт с бэком (мета строки DL2 — тот же контейнер, где лежат cells[<binding>].blank / .dir / .isReadOnly):
//   ячейка: `_DLRow.cells[<binding>].provenance` ('manual' | 'approved' | 'computed'), `.status`, `.horizon` ('tactical' | 'strategic' | 'T' | 'S');
//   строка (запасной путь для всех ячеек строки): `_DLRow.plan = {provenance?, status?, horizon?}`;
//   колонка (заголовок): `attr_col.horizon` либо `attr_col.plan_horizon` ('tactical' | 'strategic');
//   строка: `_DLRow.status_chips` — массив чипов.
// Классы ставятся ТОЛЬКО при наличии плановой меты (cells[b] с одним из трёх полей либо _DLRow.plan): у прочих отчётов (M03, Баланс) меты нет — классов нет.
// Параметры корректировки в форме ячейки: секция паспорта `sections[].key === 'adjustment'` (либо kind) с полями form, param, base_measure, base_value, delta, key,
// exclude_frozen, rounding, reason, author, at, valid_until, rule_id → строки «подпись / значение» (en-ярлыки, значения как есть). Выключатель всего — fe.ux.planLevels
// (дефолт ВКЛ; выкл — ни классов, ни чипов, ни блока; секция adjustment остаётся среди движений, как любая неизвестная).

export const PLAN_LEVELS_FLAG = 'fe.ux.planLevels'

// setting — функция (key, default) → значение; нет функции / ошибка — ВКЛ
export function planLevels_on(setting) {
    try { return typeof setting === 'function' ? setting(PLAN_LEVELS_FLAG, true) !== false : true } catch (e) { return true }
}

const _str = (v) => (v === undefined || v === null) ? '' : String(v).trim().toLowerCase()

// нормализованный горизонт: 'tactical' | 'strategic' | ''
export function planHorizon_norm(h) {
    const s = _str(h)
    if (!s) return ''
    if (s === 't' || s === 'tactical' || s === 'tact' || s === 'тактичний' || s === 'тактический') return 'tactical'
    if (s === 's' || s === 'strategic' || s === 'strat' || s === 'стратегічний' || s === 'стратегический') return 'strategic'
    return ''
}

// статус единицы → класс ячейки ('' — без заливки: вне окна, неизвестный)
export function planStatus_class(status) {
    const s = _str(status).replace(/[\s-]+/g, '_')
    if (!s) return ''
    if (s === 'approved' || s === 'approve' || s === 'confirmed') return 'plan-approved'
    if (s === 'draft' || s === 'pending' || s === 'to_approve' || s === 'in_review' || s === 'submitted' || s === 'review' || s === 'new') return 'plan-draft'
    if (s === 'returned' || s === 'rejected' || s === 'cancelled' || s === 'canceled' || s === 'annulled' || s === 'void' || s === 'declined') return 'plan-returned'
    if (s === 'locked' || s === 'frozen' || s === 'closed') return 'plan-locked'
    return ''
}

// IE 2026 10 19 / ODOO-5800 (Igor 19.10, уровень КАМ): plan-base-changed — база строки пересеяна после правки КАМ (_DLRow.cells[b].base_changed, бэк plan_passport), подсказка BASE_CHANGED_HINT
export const PLAN_BASE_CHANGED_CLASS = 'plan-base-changed'   // IE 2026 10 19 / ODOO-5800
export const BASE_CHANGED_HINT = 'Base changed after your adjustment'   // IE 2026 10 19 / ODOO-5800
export const PLAN_CELL_CLASSES = ['plan-manual', 'plan-approved', 'plan-draft', 'plan-returned', 'plan-locked', PLAN_BASE_CHANGED_CLASS]   // IE 2026 10 19 / ODOO-5800: + plan-base-changed
export const PLAN_HORIZON_CLASSES = ['plan-horizon-tactical', 'plan-horizon-strategic']

// мета плановой ячейки: {provenance, status, horizon} либо null, если у строки нет плановой меты (ни cells[b] с этими полями, ни _DLRow.plan)
export function planCell_meta(dataItem, binding) {
    const d = dataItem && dataItem._DLRow
    if (!d || typeof d !== 'object') return null
    const c = binding !== undefined && binding !== null && binding !== '' && d.cells ? d.cells[binding] : null
    const p = d.plan && typeof d.plan === 'object' ? d.plan : null
    const has = (o, k) => !!o && o[k] !== undefined && o[k] !== null && o[k] !== ''
    const cellHas = has(c, 'provenance') || has(c, 'status') || has(c, 'horizon') || has(c, 'base_changed')   // IE 2026 10 19 / ODOO-5800: + base_changed
    if (!cellHas && !p) return null
    return {
        provenance: has(c, 'provenance') ? c.provenance : (has(p, 'provenance') ? p.provenance : ''),
        status: has(c, 'status') ? c.status : (has(p, 'status') ? p.status : ''),
        horizon: has(c, 'horizon') ? c.horizon : (has(p, 'horizon') ? p.horizon : ''),
        ...(has(c, 'base_changed') ? { base_changed: _truthy(c.base_changed) } : {}),   // IE 2026 10 19 / ODOO-5800: только у ячейки с полем
    }
}

const _truthy = (v) => v === true || v === 1 || _str(v) === 'true' || _str(v) === '1'   // IE 2026 10 19 / ODOO-5800

// подсказка ячейки по мете плана ('' — нет): база пересеяна после правки — BASE_CHANGED_HINT   // IE 2026 10 19 / ODOO-5800
export function planCell_hint(dataItem, binding) {
    const m = planCell_meta(dataItem, binding)
    return m && m.base_changed ? BASE_CHANGED_HINT : ''
}

// классы ячейки по мете: [] — ничего (нет меты / всё пусто)
export function planCell_classes(dataItem, binding) {
    const m = planCell_meta(dataItem, binding)
    if (!m) return []
    const out = []
    if (_str(m.provenance) === 'manual') out.push('plan-manual')
    const st = planStatus_class(m.status)
    if (st) out.push(st)
    if (m.base_changed) out.push(PLAN_BASE_CHANGED_CLASS)   // IE 2026 10 19 / ODOO-5800
    return out
}

// применить набор классов к элементу ячейки: ставит нужные, снимает прочие plan-* из набора. Возвращает true, если что-то поменялось
export function planCell_applyClasses(classList, want) {
    if (!classList) return false
    const w = new Set(want || [])
    let changed = false
    for (const c of PLAN_CELL_CLASSES) {
        const has = classList.contains(c)
        if (w.has(c) && !has) { classList.add(c); changed = true } else if (!w.has(c) && has) { classList.remove(c); changed = true }
    }
    return changed
}

// класс заголовка колонки по горизонту колонки ('' — нет)
export function planHeader_class(attr_col) {
    if (!attr_col || typeof attr_col !== 'object') return ''
    const h = planHorizon_norm(attr_col.horizon !== undefined && attr_col.horizon !== null ? attr_col.horizon : (attr_col.plan_horizon !== undefined ? attr_col.plan_horizon : (attr_col.params && attr_col.params.horizon)))
    return h ? 'plan-horizon-' + h : ''
}

export function planHeader_applyClass(classList, cls) {
    if (!classList) return false
    let changed = false
    for (const c of PLAN_HORIZON_CLASSES) {
        const has = classList.contains(c)
        if (c === cls && !has) { classList.add(c); changed = true } else if (c !== cls && has) { classList.remove(c); changed = true }
    }
    return changed
}

const HORIZON_LETTER = { tactical: 'T', strategic: 'S' }
const HORIZON_TITLE = { tactical: 'Tactical', strategic: 'Strategic' }

// чипы статуса по горизонтам из _DLRow.status_chips: [{text, css, title, status, horizon, due}]; нет / не массив — []
export function planChips_of(dataItem) {
    const d = dataItem && dataItem._DLRow
    const list = d && Array.isArray(d.status_chips) ? d.status_chips : null
    if (!list || !list.length) return []
    const out = []
    for (const ch of list) {
        if (!ch || typeof ch !== 'object') continue
        const hz = planHorizon_norm(ch.horizon)
        const letter = hz ? HORIZON_LETTER[hz] : String(ch.horizon || '').trim().slice(0, 1).toUpperCase()
        const title = ch.title !== undefined && ch.title !== null && String(ch.title) !== '' ? String(ch.title) : String(ch.status || '')
        if (!title && !letter) continue
        const st = planStatus_class(ch.status)
        const due = ch.due ? String(ch.due) : ''
        out.push({
            text: letter && title ? letter + ' · ' + title : (letter || title),
            css: 'status-chip plan-chip' + (st ? ' plan-chip-' + st.slice(5) : ''),   // plan-chip-approved / -draft / -returned / -locked
            title: (hz ? HORIZON_TITLE[hz] : String(ch.horizon || '')) + (title ? ' — ' + title : '') + (due ? ', due ' + due : ''),
            status: ch.status === undefined || ch.status === null ? '' : String(ch.status),
            horizon: hz || String(ch.horizon || ''),
            due,
        })
    }
    return out
}

// ----- форма ячейки: секция «Adjustment parameters» -----

export const ADJUSTMENT_KEY = 'adjustment'
export const ADJUSTMENT_FIELDS = [
    ['form', 'Form'],
    ['param', 'Parameter'],
    ['base_measure', 'Base measure'],
    ['base_value', 'Base value'],
    ['delta', 'Delta'],
    ['key', 'Key'],
    ['exclude_frozen', 'Exclude frozen'],
    ['rounding', 'Rounding'],
    ['reason', 'Reason'],
    ['author', 'Author'],
    ['at', 'At'],
    ['valid_until', 'Valid until'],
    ['rule_id', 'Rule'],
    ['provenance', 'Provenance'],   // IE 2026 10 19 / ODOO-5800 (KAM seed)
    ['base_changed', 'Base changed'],   // IE 2026 10 19 / ODOO-5800 (KAM seed)
]

export function adjustmentSection_is(sec) {
    return !!sec && typeof sec === 'object' && (sec.key === ADJUSTMENT_KEY || sec.kind === ADJUSTMENT_KEY)
}

// значение как есть: boolean → Yes / No, массив → через запятую, объект → JSON, прочее — строкой
export function adjustment_value(v) {
    if (v === undefined || v === null || v === '') return ''
    if (typeof v === 'boolean') return v ? 'Yes' : 'No'
    if (Array.isArray(v)) return v.map(x => adjustment_value(x)).filter(x => x !== '').join(', ')
    if (typeof v === 'object') { try { return JSON.stringify(v) } catch (e) { return String(v) } }
    return String(v)
}

// строки «подпись / значение» секции adjustment: готовые sec.rows (если бэк их дал) — как есть; иначе из полей секции (sec.<поле> либо sec.fields / sec.data / sec.adjustment).
// Пустые поля пропускаются; порядок — ADJUSTMENT_FIELDS, затем неизвестные поля контейнера как есть (ярлык — имя поля)
export function adjustment_rows(sec) {
    if (!adjustmentSection_is(sec)) return []
    if (Array.isArray(sec.rows) && sec.rows.length) return sec.rows.filter(r => Array.isArray(r) && r.length >= 2)
    const src = (sec.fields && typeof sec.fields === 'object' && !Array.isArray(sec.fields)) ? sec.fields
        : (sec.data && typeof sec.data === 'object' && !Array.isArray(sec.data)) ? sec.data
        : (sec.adjustment && typeof sec.adjustment === 'object' && !Array.isArray(sec.adjustment)) ? sec.adjustment
        : sec
    const skip = new Set(['key', 'kind', 'title', 'title_en', 'rows', 'summary', 'placement', 'note', 'fields', 'data', 'adjustment', 'title_link'])
    const rows = []
    const used = new Set()
    for (const [k, label] of ADJUSTMENT_FIELDS) {
        used.add(k)
        if (src === sec && k === 'key' && src.key === ADJUSTMENT_KEY) continue   // ключ секции — не поле корректировки
        const v = adjustment_value(src[k])
        if (v !== '') rows.push([label, v])
    }
    for (const k of Object.keys(src)) {
        if (used.has(k) || (src === sec && skip.has(k))) continue
        const v = adjustment_value(src[k])
        if (v !== '') rows.push([k, v])
    }
    return rows
}

// блок формы: {key: 'adjustment', title, sections: [{title: '', rows}], summary} либо null, если секции нет / строк нет / выключено
export function adjustment_block(sections, on = true) {
    if (on === false || !Array.isArray(sections)) return null
    const sec = sections.find(adjustmentSection_is)
    if (!sec) return null
    const rows = adjustment_rows(sec)
    if (!rows.length) return null
    const first = rows.find(r => r[0] === 'Form') || rows[0]
    const summary = sec.summary ? String(sec.summary) : rows.slice(0, 2).map(r => r[0] + ': ' + r[1]).join(' · ')
    return { key: ADJUSTMENT_KEY, title: sec.title ? String(sec.title) : 'Adjustment parameters', sections: [{ title: '', rows, note: sec.note || '' }], summary, form: first ? first[1] : '' }
}

// секции паспорта без adjustment (чтобы она не попала в DETAILS · MOVEMENTS, когда блок включён)
export function sections_withoutAdjustment(sections, on = true) {
    if (on === false || !Array.isArray(sections)) return sections
    return sections.filter(s => !adjustmentSection_is(s))
}
